export class AvfOrdonnanceInformationsForm {
  prescriptionMois: number;
  dureeMin: number;
  dureeMax: number;
  debitMin: number;
  debitMax: number;

  constructor(
    prescriptionMois: number,
    dureeMin: number,
    dureeMax: number,
    debitMin: number,
    debitMax: number,
  ) {
    this.prescriptionMois = prescriptionMois;
    this.dureeMin = dureeMin;
    this.dureeMax = dureeMax;
    this.debitMin = debitMin;
    this.debitMax = debitMax;
  }

  toAPI(): AvfOrdonnanceInformationsFormAPI {
    return {
      prescription_duree: `${this.prescriptionMois} mois`,
      duree_min: this.dureeMin,
      duree_max: this.dureeMax,
      debit_min: this.debitMin,
      debit_max: this.debitMax,
    };
  }
}

export type AvfOrdonnanceInformationsFormAPI = {
  prescription_duree: string;
  duree_min: number;
  duree_max: number;
  debit_min: number;
  debit_max: number;
};
